import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';


Vue.use(Router);

const router = new Router({
   base: '/',
   mode: 'hash',
   linkActiveClass: 'active',
   routes: paths
});


router.beforeEach((to, from, next) => {
   let logged = window.localStorage.getItem('stAuthToken');

   // console.log('Router:', to, from);

   if (to.name === 'NewAffiliate') {
      if (logged) {
         next('/404');
      } else {
         next();
      }
   } else if (to.name !== 'Login' && !logged) {
      next({
         name: 'Login',
         replace: true
      });

   } else if (to.name === 'Login' && logged) {
      window.getApp.$emit('APP_LOGOUT');
      next();

   } else {

      if (!to.matched.length) {
         next('/404');
      } else {
         if ([to.name, from.name].indexOf('Login') < 0) {
            if (!window.nprogress.isStarted()) {
               window.nprogress.start();
            }
         }

         if (window.getApp && window.getApp.$uCan && !window.getApp.$uCan({ route: to.path })) {
            next('/404');
         } else {
            next();
         }
      }
   }

});

router.afterEach((to, from) => {

   if ([to.name, from.name].indexOf('Login') < 0) {
      window.nprogress.done();
   }

   if (to.name !== 'Login' && window.getApp.$store.state.company.user.changePin) {
      window.getApp.$notifyUser({
         message: 'Sua senha precisa ser alterada!',
         type: 'info',
         position: 'top'
      });

      setTimeout(() => {
         window.getApp.showModal('ChangePin');
      }, (from.name === 'Login') ? 3000 : 400);

   }


});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js